module.exports = globalThis.__webpack_lazy_fm__.systemjs('@onvioar/due-dates');